import { render, staticRenderFns } from "./ThreatList.vue?vue&type=template&id=09621f40&"
import script from "./ThreatList.vue?vue&type=script&lang=ts&"
export * from "./ThreatList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports